import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { colours } from '../../../Data/Tags';
import { classNames } from '../../../Services/helpers';

const TagColour = ({label, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const changeVal = (val) => {
        updateField(name, val);
        onChange && onChange(val);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <fieldset>
            <legend className="sr-only">{label}</legend>
            <div className="flex flex-row gap-x-2">
                {Object.values(colours).map((colour, index) => {
                    if (!colour.real) {
                        return null;
                    }
                    return <div key={index}
                        className={classNames(
                        'p-1 grow rounded-full cursor-pointer border-2',
                        value === colour.name ? colour.border : 'border-transparent'
                        )}
                        onClick={() => changeVal(colour.name)}
                    >
                        <div className={classNames('w-full h-5 rounded-full', colour.bg)}>
                            &nbsp;
                        </div>
                    </div>
                })}
            </div>
        </fieldset>

    </CommonFieldWrapper>
}


export default TagColour;
